import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';

import CheckIcon from '@mui/icons-material/Check';
import { Divider, Menu, MenuItem } from '@mui/material';

import { isFeatureEnabled } from '@/constants/featureFlags';
import { ROUTE_ROLES } from '@/constants/roles';
import useDashboard from '@/hooks/useDashboard';
import { resetAllStates } from '@/redux/actions/globalActions';
import GearIcon from '@assets/icons/GearSix.svg';
import NotificationsIcon from '@assets/icons/Notifications.svg';
import ProfileIcon from '@assets/icons/Profile.svg';
import VisitAbsencesIcon from '@assets/icons/VisitAbsences.svg';
import VisitAbsencesLateIcon from '@assets/icons/VisitAbsencesLate.svg';
import QuestionIcon from '@assets/icons/Question.svg';
import useAuthService from '@services/auth';
import useNotificationService from '@services/notification';
import useVisitAbsencesService from '@services/visits-absences';

import { redirectUser } from '../../../../utils/redirect';
import ContentFormModal from '../../modals/ContentForm';
import HelpSupportModal from '../../modals/HelpSupportModal';
import IconButton from '../IconButton';
import { Container, NotificationBadge, NotificationsContent } from './styles';

const NavbarIcons = ({}) => {
    const navigate = useNavigate();
    const { logout, setCurrentUserRole: setReduxCurrentUser } = useAuthService();
    const dispatch = useDispatch();
    const { openSettingsModal } = useDashboard();
    const { getAllNotificationsUser } = useNotificationService();
    const { getRegularityStatus } = useVisitAbsencesService();
    const user = useSelector((state) => state.auth.user);
    const notificationsEmpty = useSelector((state) => state.notification.empty);
    const { regularityStatus } = useSelector((state) => state.auth);

    const [menuAnchor, setMenuAnchor] = useState(null);
    const [showSettingsMenu, setShowSettingsMenu] = useState(false);
    const [showChangeRoleMenu, setShowChangeRoleMenu] = useState(false);
    const [menuChangeRole, setMenuChangeRole] = useState(null);
    const [menuHelpAnchor, setMenuHelpAnchor] = useState(null);
    const [showHelpMenu, setShowHelpMenu] = useState(false);
    const [currentUserRole, setCurrentUserRole] = useState(Number(sessionStorage.getItem('currentUserRole')));
    const consultantId = sessionStorage.getItem('consultant_id') ?? null;
    const segment = useSelector((state) => state.auth.currentSegment);

    const [showContentFormModal, setShowContentFormModal] = useState(false);
    const [showHelpModal, setShowHelpModal] = useState(false);
    const handleUserRoleChange = (role) => {
        if (role !== currentUserRole) {
            setCurrentUserRole(role);
            sessionStorage.setItem('currentUserRole', Number(role));
            setReduxCurrentUser(Number(role));
            navigate('/');
        }
    };
    const [existNotification, setExistNotification] = useState(false);

    const handleOpenSettings = (evt) => {
        setMenuAnchor(evt.currentTarget);
        setShowSettingsMenu(true);
    };

    const handleCloseSettings = () => {
        setMenuAnchor(null);
        setShowSettingsMenu(false);
    };

    const handleSettingsModal = () => {
        handleCloseSettings();
        openSettingsModal();
    };

    const handleLogout = () => {
        sessionStorage.removeItem('consultant_id');
        sessionStorage.removeItem('consultant');
        sessionStorage.removeItem('currentUserRole');
        logout();

        handleCloseSettings();
        navigate('/');
    };

    const handleCloseHelp = () => {
        setMenuHelpAnchor(null);
        setShowHelpMenu(false);
    };

    const handleOpenChangeRole = (evt) => {
        setMenuChangeRole(evt.currentTarget);
        setShowChangeRoleMenu(true);
    };

    const handleCloseChangeRole = () => {
        setMenuChangeRole(null);
        setShowChangeRoleMenu(false);
    };

    const handleContentSupportModal = () => {
        handleCloseHelp();
        setShowContentFormModal(!showContentFormModal);
    };

    const handleOpenHelpModal = () => {
        setShowHelpModal(true);
    };

    const handleCloseHelpModal = () => {
        setShowHelpModal(false);
    };

    const handleTechnicalSupport = () => {
        window.open('https://wa.me/5531972671555', '_blank');
    };

    const handleITSupport = () => {
        window.open('https://wa.me/31996114688', '_blank');
    };

    function getAllNotifications() {
        getAllNotificationsUser()
            .then((resp) => {
                dispatch({ type: 'SET_NOTIFICATIONS', payload: resp.data });
                setExistNotification(resp.data.length > 0 ? true : false);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const checkRegularityStatus = () => {
        getRegularityStatus()
            .then((resp) => {
                dispatch({ type: 'SET_REGULARITY_STATUS', payload: resp.data });
            })
            .catch((error) => {
                console.log('Error checking regularity status:', error);
                dispatch({ type: 'SET_REGULARITY_STATUS', payload: null });
            });
    };

    //         }
    //     }, 60000);
    // }

    useEffect(() => {
        // Só busca notificações se a feature estiver habilitada
        if (isFeatureEnabled('NOTIFICACOES', segment)) {
            getAllNotifications();
        }
        if (currentUserRole == 2) {
            checkRegularityStatus();
        }
    }, [currentUserRole]);

    useEffect(() => {
        // Só busca notificações se a feature estiver habilitada
        if (isFeatureEnabled('NOTIFICACOES', segment)) {
            getAllNotifications();
        }
    }, [notificationsEmpty, segment]);

    return (
        <>
            <Container data-tour="1">
                {isFeatureEnabled('NOTIFICACOES', segment) && (
                    <NotificationsContent>
                        <IconButton
                            variant={'transparent'}
                            icon={NotificationsIcon}
                            onClick={() => navigate(redirectUser(currentUserRole, 'notificacoes'))}
                            disabled={Boolean(consultantId)}
                        />
                        {existNotification && <NotificationBadge />}
                    </NotificationsContent>
                )}

                {currentUserRole == 2 && segment == 1 ? (
                    <IconButton
                        variant={'transparent'}
                        icon={regularityStatus === 'late' || regularityStatus === 'pending' ? VisitAbsencesLateIcon : VisitAbsencesIcon}
                        onClick={() => navigate(redirectUser(currentUserRole, 'justificativas'))}
                        disabled={Boolean(consultantId)}
                    />
                ) : null}

                <IconButton
                    className="track-need-help"
                    variant={'transparent'}
                    icon={QuestionIcon}
                    onClick={() => {
                        segment == 2 ? window.open('https://wa.me/5531995918666', '_blank') : handleOpenHelpModal();
                    }}
                    disabled={Boolean(consultantId)}
                />

                {user?.roles?.length > 1 ? (
                    <IconButton
                        variant={'transparent'}
                        icon={ProfileIcon}
                        onClick={handleOpenChangeRole}
                        disabled={Boolean(consultantId)}
                    />
                ) : null}

                <IconButton variant={'transparent'} icon={GearIcon} onClick={handleOpenSettings} disabled={Boolean(consultantId)} />
            </Container>
            <Menu
                id="basic-menu"
                anchorEl={menuAnchor}
                open={showSettingsMenu}
                onClose={handleCloseSettings}
                MenuListProps={{
                    'aria-labelledby': 'basic-button'
                }}
            >
                <MenuItem onClick={handleSettingsModal}>Configurações do Perfil</MenuItem>
                <Divider />
                <MenuItem onClick={handleLogout}>Sair</MenuItem>
            </Menu>

            <Menu
                id="basic-menu"
                anchorEl={menuChangeRole}
                open={showChangeRoleMenu}
                onClose={handleCloseChangeRole}
                MenuListProps={{
                    'aria-labelledby': 'basic-button'
                }}
            >
                {user.roles &&
                    user.roles.map((role, index) => (
                        <>
                            <MenuItem
                                key={`${index}_${role}`}
                                onClick={() => handleUserRoleChange(role)}
                                style={{
                                    textTransform: 'capitalize',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                    color: role === currentUserRole ? '#3A6647' : '',
                                    fontWeight: role === currentUserRole ? 600 : 400
                                }}
                            >
                                {ROUTE_ROLES[role]}
                                {role === currentUserRole ? <CheckIcon color="#3A6647" /> : ''}
                            </MenuItem>
                            {index + 1 < user.roles.length && <Divider />}
                        </>
                    ))}
                {/* <MenuItem onClick={() => alert('trocar perfil')}>Administrador</MenuItem> */}
            </Menu>
            {showContentFormModal && <ContentFormModal open={showContentFormModal} handleClose={handleContentSupportModal} />}

            <HelpSupportModal
                open={showHelpModal}
                onClose={handleCloseHelpModal}
                onSelectITSupport={handleITSupport}
                onSelectTechnicalSupport={handleTechnicalSupport}
            />
        </>
    );
};
export default NavbarIcons;

NavbarIcons.propTypes = {
    withGraph: PropTypes.bool
};
